module.exports = __webpack_public_path__ + "media/images/arrow-3911873bab83c4849ba2bb0651b02d0a.svg";